// Text field validations
import { Iti } from 'intl-tel-input';

function showHideErrorMessage(
  className: string,
  error: boolean,
  id: string,
  isPhone = false,
  customregexindex?: number
) {
  let inputContainer = isPhone
    ? document.querySelector(`#${id}`)?.parentElement?.parentElement
    : document.querySelector(`#${id}`)?.parentElement;

  inputContainer ??= isPhone
    ? document.getElementById(`${id}`)?.parentElement?.parentElement?.parentElement
    : document.getElementById(`${id}`)?.parentElement;

  let errorDiv: HTMLElement | null;
  if (customregexindex != null) {
    const errorDivs = inputContainer?.querySelectorAll(`.${className}`) as NodeListOf<HTMLElement>;
    errorDiv = errorDivs[customregexindex] || null;
  } else {
    errorDiv = inputContainer?.querySelector(`.${className}`) as HTMLElement | null;
  }
  const errorListValidation = errorDiv?.parentElement;
  const hideErrorMessage = 'input-hidden-error-messagge-vr';
  const idSplit = id?.split('-');
  let supportingText: HTMLElement | null = null;

  if (idSplit.length > 0) {
    // Get supportive text element
    supportingText = document.querySelector(
      `#supportive-text-form-text-${idSplit[idSplit.length - 1]}`
    ) as HTMLElement;
  }

  // Get flatpickr error element
  const flatpickrElement = document.querySelector(`#flatpickr-error-${id}`) as HTMLElement;

  if (error) {
    const allErrorsHidden =
      errorListValidation?.querySelectorAll(`.${hideErrorMessage}`).length ===
      errorListValidation?.children.length;
    if (!allErrorsHidden) {
      return '';
    }
    if (errorDiv) {
      errorDiv.classList.remove(hideErrorMessage);
    }
    // Hide supporting text if there exists any
    if (supportingText) {
      showHideSupportingText(supportingText, false);
    }

    // Hide flatpickr error if there exists any
    if (flatpickrElement && !flatpickrElement?.classList?.contains('hidden')) {
      flatpickrElement?.classList?.add('hidden');
      inputContainer?.closest('.text')?.classList?.remove('flatepickr-error-input');
    }
  } else if (errorDiv) {
    errorDiv.classList.add(hideErrorMessage);
  }

  // Show supporting text if there exists any
  const allErrorsHidden =
    errorListValidation?.querySelectorAll(`.${hideErrorMessage}`).length ===
    errorListValidation?.children.length;

  if (allErrorsHidden && supportingText) {
    showHideSupportingText(supportingText, true);
  }

  return null;
}

function showHideSupportingText(supportingText: HTMLElement, show: boolean): void {
  if (show) {
    supportingText.style.display = '';
  } else {
    supportingText.style.display = 'none';
  }
}

//custom regex
//mandatory field
export function vrCustomRegex(
  value: string,
  validation: string,
  id: string,
  customregex: string,
  regexindex: number,
  errorcount: number
) {
  if (customregex) {
    const regex = new RegExp(customregex);
    if (!regex.test(value)) {
      showHideErrorMessage(validation, true, id, false, regexindex);
      return false;
    }
  }
  if (!errorcount) {
    showHideErrorMessage(validation, false, id);
  }
  return true;
}

//mandatory field
export function vrMandatoryField(value: string, validation: string, id: string, isPhone = false) {
  const isEmpty = !value?.trim();
  showHideErrorMessage(validation, isEmpty, id, isPhone);
  return !isEmpty;
}

export function vrNoSpecialCharactersOrEmojis(value: string, validation: string, id: string) {
  // Regex to match special characters and emojis except .,-
  if (/[^ \p{L}\p{N}.\-']/gu.test(value) || /[\uD83C-\uDBFF\uDC00-\uDFFF]+/gu.test(value)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  if (!/[\p{L}\p{N}]/u.test(value)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

//error-input
export function vrAlphabeticalSpacesSpecialcharacters(
  value: string,
  validation: string,
  id: string
): boolean {
  if (!/^[^\d]*$/.test(value)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrMin2CharactersMax50characters(
  value: string,
  validation: string,
  id: string
): boolean {
  if (value.length < 2 || value.length > 50) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrMin1CharactersMax50characters(
  value: string,
  validation: string,
  id: string
): boolean {
  if (value.length < 1 || value.length > 50) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrSignatureSurnameName(
  signature: string,
  firstName: string,
  lastName: string,
  validation: string,
  id: string
): boolean {
  const normalizedSignature = signature.trim();
  const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
  const fullNameRevert = `${lastName.trim()} ${firstName.trim()}`.trim();
  if (normalizedSignature !== fullName && normalizedSignature !== fullNameRevert) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrSignatureExactMatch(
  signature: string,
  expectedName: string,
  validation: string,
  id: string
): boolean {
  if (signature.trim().toLowerCase() !== expectedName.trim().toLowerCase()) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrOnlyCharactersAndNumber(
  address: string,
  validation: string,
  id: string
): boolean {
  if (!/^[a-zA-Z0-9]+$/.test(address)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrMax100Characters(address: string, validation: string, id: string): boolean {
  if (address.length > 100) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrOnlyNumericMin3Digit(address: string, validation: string, id: string): boolean {
  if (address.length > 0) {
    if (address.length < 3 || !/^\d+$/.test(address)) {
      showHideErrorMessage(validation, true, id);
      return false;
    }
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrPostalcodeCountrysStandard(validation: string, id: string): boolean {
  if (validation) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

// Credit Card Expiration and Document Date Validation
export function vrFutureDateControlAndFormat(
  expirationDate: string,
  validation: string,
  id: string
): boolean {
  if (!expirationDate) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  if (!/^\d{2}\/\d{2}$/.test(expirationDate)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  const [month, year] = expirationDate.split('/');
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100; // Get last two digits of current year

  // Check if month is between 1 and 12
  if (monthNum < 1 || monthNum > 12) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  // Check if year is equal to or greater than current year
  if (yearNum < currentYear) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  const expirationDateObj = new Date(2000 + yearNum, monthNum - 1);

  if (expirationDateObj <= currentDate) {
    showHideErrorMessage(validation, true, id);
    return false;
  }

  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrEmailCheckTwoLetterMailAndConfirmEmail(
  email: string,
  validation: string,
  id: string
): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrEmailCheckOneLetterMailAndConfirmEmail(
  email: string,
  validation: string,
  id: string
): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrValidateConfirmEmail(
  email: string,
  currentemail: string,
  validation: string,
  id: string
): boolean {
  if (email !== currentemail) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vMin6DigitAndMax13Digit(value: string, validation: string, id: string): boolean {
  if (value.length > 0) {
    if (value.length < 6 || value.length > 13 || !/^\d+$/.test(value)) {
      showHideErrorMessage(validation, true, id);
      return false;
    }
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrAlphabeticalSpacesSpecialcharactersNumber(
  value: string,
  validation: string,
  id: string
): boolean {
  if (!/^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};:'",.<>?/\\|]+$/.test(value)) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrMax500Characters(address: string, validation: string, id: string): boolean {
  if (address.length > 500) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrDateNoBefore01011990(date: string, validation: string, id: string): boolean {
  const selectDate = new Date(date);
  if (selectDate < new Date('1900-01-01')) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrDatePastDate(date: string, validation: string, id: string): boolean {
  const selectDate = new Date(date);
  const now = new Date();

  if (selectDate > now) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  if (isNaN(selectDate.getTime())) {
    showHideErrorMessage(validation, true, id);
    return false;
  }
  showHideErrorMessage(validation, false, id);
  return true;
}

export function vrPhoneNumber(iti: Iti, validation: string, id: string): boolean {
  const isValid = iti.isValidNumber() as boolean;
  showHideErrorMessage(validation, !isValid, id, true);
  return isValid;
}

export function vrValidZipcodeAddress(
  zipCodeFieldElement: Element,
  validation: string,
  id: string
): boolean {
  if (validation) {
    showHideErrorMessage(validation, true, id);
    zipCodeFieldElement?.classList.add('error-input');
    return false;
  }
  showHideErrorMessage(validation, false, id);
  zipCodeFieldElement?.classList.remove('error-input');

  return true;
}
